import React from "react";
import DatePicker from "react-modern-calendar-datepicker";
import { DatePickerContainer } from "./style.js";
import moment from "moment-jalaali";
const DatePickerComponent = ({
  name,
  value,
  onChange,
  label,
  error,
  required,
}) => {
  const dateObject = () => {
    if (!value) {
      return null;
    } else {
      let date = moment(value, "YYYY-M-D");
      return {
        year: date.jYear(),
        month: date.jMonth() + 1 <= 12 ? date.jMonth() + 1 : 1,
        day: date.jDate(),
      };
    }
  };
  const handleChange = (date) => {
    let result = moment(
      date.year + "-" + date.month + "-" + date.day,
      "jYYYY-jM-jD"
    );
    onChange({ target: { value: result.format("YYYY-M-D"), name: name } });
  };
  return (
    <DatePickerContainer error={error} required={required}>
      <label>{label}</label>
      <div className="date-area">
        <DatePicker
          value={dateObject()}
          name={name}
          onChange={handleChange}
          shouldHighlightWeekends
          locale="fa"
        />
        <span className="error">{error}</span>
      </div>
    </DatePickerContainer>
  );
};
const isEqual = (prevProps, nextProps) => {
  return (
    prevProps.value === nextProps.value &&
    prevProps.error === nextProps.error &&
    prevProps.label === nextProps.label &&
    prevProps.name === nextProps.name
  );
};
export default React.memo(DatePickerComponent, isEqual);